

import React, { useState, useEffect } from 'react';
import ImageCarussel from '../Image-Carussel/ImageCarussel';
import './MessagePage.css';

const MessagePage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sentSuccesfull, setSentSuccesfull] = useState(0);

  const sendEmail = async () => {
    setSentSuccesfull(3);

    try {
      const response = await fetch('https://ernaehrungsberatung-katja-baer-hanuja.de/api/send-message', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        
        body: JSON.stringify({
          "email":email,
          "message":message
        }),
      });


      if (response.ok) {
        setSentSuccesfull(1);
        setTimeout(() => {
          setSentSuccesfull(0);
        }, 5000);
      } else {
        setSentSuccesfull(2);
        setTimeout(() => {
          setSentSuccesfull(0);
        }, 4000);

      }
    } catch (error) {
      console.error('Error sending message:', error);
      setSentSuccesfull(2);
      setTimeout(() => {
        setSentSuccesfull(0);
      }, 4000);
    }
  };

  return (
    <div className={(window.innerWidth < 1500) ? 'CompletePageMessage' : 'CompletePage'}>
      {window.innerWidth > 1500 && (
        <div className="WelcomePagePictures">
          <ImageCarussel />
        </div>
      )}
      <div className="WelcomePageContent">
        <div className="ContactPopUpWrapper">
          <div className="SendMessageLabel">Senden Sie mir eine Nachricht!</div>
          <input
            type="email"
            className="EmailInput"
            placeholder="Ihre Email Adresse"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <textarea
            type="text"
            className="TextInput"
            placeholder="Ihre Nachricht"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          {sentSuccesfull === 0 ?
            <div className="SendButton" onClick={sendEmail}>
              Senden
            </div> : sentSuccesfull === 1 ? <div>
              Das Senden ihrer Nachricht war erfolgreich!
            </div> : sentSuccesfull === 2 ? <div> Das Senden ihrer Nachricht ist fehlgeschlagen
            </div> : <div> Ihre Nachricht wird verarbeitet!</div>}

        </div>
      </div>
    </div>
  );
};

export default MessagePage;

